module.exports = __webpack_public_path__ + "img/Group_28491.23447b7a.png";